import React, { useState } from 'react'
import { Newspaper, BadgeCheck, TrendingUp } from 'lucide-react'
import Badge from './ui/Badge'
import { useDesk } from '../deskContext'
import { relativeTime } from '../utils/format'
import { impactTone, toneColor } from '../utils/tone'

export default function NewsFeed({ news }) {
  const categories = useDesk().newsCategories
  const [active, setActive] = useState(categories[0].id)
  const items = news?.[active] ?? []

  return (
    <div className="onds-card p-5 md:p-6 flex flex-col h-full">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Newspaper className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
          <h2 className="text-lg font-bold">Intelligence Feed</h2>
        </div>
        <div className="flex gap-1 p-1 rounded-lg" style={{ backgroundColor: 'var(--onds-surface)' }}>
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActive(cat.id)}
              className="px-3 py-1.5 rounded-md text-xs font-semibold transition"
              style={
                active === cat.id
                  ? { backgroundColor: 'var(--onds-accent)', color: '#0a0e17' }
                  : { color: 'var(--onds-text-dim)' }
              }
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3 overflow-y-auto onds-scrollbar pr-1" style={{ maxHeight: 420 }}>
        {items.map((item) => (
          <article
            key={item.id}
            className="rounded-xl p-4 border transition hover:translate-x-0.5"
            style={{ backgroundColor: 'var(--onds-surface)', borderColor: 'var(--onds-border)' }}
          >
            <div className="flex items-center justify-between gap-2 mb-2">
              <span className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-[var(--onds-text-dim)] min-w-0">
                {item.official && <BadgeCheck className="h-3.5 w-3.5 shrink-0" style={{ color: 'var(--onds-accent)' }} />}
                <span className="truncate">{item.source}</span>
              </span>
              <div className="flex items-center gap-2 shrink-0">
                <Badge tone={impactTone(item.impact)}>{item.impact}</Badge>
                <span className="text-[11px] text-[var(--onds-text-dim)]">{relativeTime(item.publishedAt)}</span>
              </div>
            </div>
            <h3 className="font-semibold leading-snug mb-1">{item.title}</h3>
            <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed">{item.summary}</p>
            {item.implication && (
              <div className="mt-2 flex items-start gap-1.5 text-xs leading-relaxed" style={{ color: toneColor(impactTone(item.impact)) }}>
                <TrendingUp className="h-3.5 w-3.5 mt-0.5 shrink-0" />
                <span><span className="font-semibold">Price impact:</span> {item.implication}</span>
              </div>
            )}
          </article>
        ))}
      </div>
    </div>
  )
}
